import React from 'react';
import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const Construction = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const goBack = () => {
        navigate(-1);
    };

    return (
        <div className='flex justify-center items-center h-full'>
            <Result
                status="404"
                title={t('common.construction')}
                subTitle={t('common.construction_exp')}
                extra={<Button type="primary" key="console" onClick={() => goBack()}>{t('common.go_back')}</Button>}
            />
        </div>
    )
}

export default Construction